import script from "./ProductFormShablone.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductFormShablone.vue?vue&type=script&setup=true&lang=js"

import "./ProductFormShablone.vue?vue&type=style&index=0&id=8fec45d8&scoped=true&lang=css"
import "./ProductFormShablone.vue?vue&type=style&index=1&id=8fec45d8&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8fec45d8"]])

export default __exports__